<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>

  <main class="cd-main" aria-label="Insights and Analytics">
    <div>
      <h1 class="cd-title">Insights &amp; Analytics</h1>
      <p class="cd-subtitle">Platform-wide activity and usage metrics</p>
    </div>

    @if (loading) {
      <p class="in-loading">Loading analytics...</p>
    }

    @if (error) {
      <p class="in-error" role="alert">Unable to load analytics. Please try again later.</p>
    }

    @if (!loading && !error && data) {
      <!-- Top-line stat cards -->
      <section class="in-stats" aria-label="Key metrics">
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.organizations.districts }}</div>
          <div class="in-stat-label">Districts</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.organizations.schools }}</div>
          <div class="in-stat-label">Schools</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.users.total }}</div>
          <div class="in-stat-label">Total Users</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.users.students }}</div>
          <div class="in-stat-label">Students</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.users.staff }}</div>
          <div class="in-stat-label">Staff</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.users.administrators }}</div>
          <div class="in-stat-label">Administrators</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.content.posts }}</div>
          <div class="in-stat-label">Posts</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.content.comments }}</div>
          <div class="in-stat-label">Comments</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.content.messages }}</div>
          <div class="in-stat-label">Messages</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.content.events }}</div>
          <div class="in-stat-label">Calendar Events</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.connections.accepted }}</div>
          <div class="in-stat-label">Connections</div>
        </div>
        <div class="in-stat-card">
          <div class="in-stat-value">{{ data.moderation.totalReports }}</div>
          <div class="in-stat-label">Reported Content</div>
        </div>
      </section>

      <!-- Charts -->
      <section class="in-charts" aria-label="Charts">
        <div class="in-chart-card">
          <h2 class="in-chart-title">Users by Type</h2>
          <div class="in-chart-canvas">
            <canvas
              baseChart
              [type]="usersChartType"
              [data]="usersChartData"
              [options]="doughnutOptions"
            ></canvas>
          </div>
        </div>

        <div class="in-chart-card">
          <h2 class="in-chart-title">Content Activity</h2>
          <div class="in-chart-canvas">
            <canvas
              baseChart
              [type]="contentChartType"
              [data]="contentChartData"
              [options]="barOptions"
            ></canvas>
          </div>
        </div>

        <div class="in-chart-card">
          <h2 class="in-chart-title">
            Student Profile Completion
            <span class="in-chart-note">Avg {{ data.profileCompletion.average }}%</span>
          </h2>
          <div class="in-chart-canvas">
            <canvas
              baseChart
              [type]="completionChartType"
              [data]="completionChartData"
              [options]="barOptions"
            ></canvas>
          </div>
        </div>

        <div class="in-chart-card">
          <h2 class="in-chart-title">Connections</h2>
          <div class="in-chart-canvas">
            <canvas
              baseChart
              [type]="connectionsChartType"
              [data]="connectionsChartData"
              [options]="doughnutOptions"
            ></canvas>
          </div>
        </div>

        <div class="in-chart-card">
          <h2 class="in-chart-title">Moderation Activity</h2>
          @if (data.moderation.totalReports === 0) {
            <p class="in-empty">No reports yet</p>
          } @else {
            <div class="in-chart-canvas">
              <canvas
                baseChart
                [type]="moderationChartType"
                [data]="moderationChartData"
                [options]="doughnutOptions"
              ></canvas>
            </div>
          }
        </div>

        <div class="in-chart-card">
          <h2 class="in-chart-title">Reports by Reason</h2>
          @if (data.moderation.totalReports === 0) {
            <p class="in-empty">No reports yet</p>
          } @else {
            <div class="in-chart-canvas">
              <canvas
                baseChart
                [type]="reasonsChartType"
                [data]="reasonsChartData"
                [options]="barOptions"
              ></canvas>
            </div>
          }
        </div>

        <div class="in-chart-card in-chart-wide">
          <h2 class="in-chart-title">
            Most Used Features
            <span class="in-chart-note">Last 30 days</span>
          </h2>
          @if (data.featureUsage.length === 0) {
            <p class="in-empty">No usage data yet</p>
          } @else {
            <div class="in-chart-canvas">
              <canvas
                baseChart
                [type]="featureChartType"
                [data]="featureChartData"
                [options]="horizontalBarOptions"
              ></canvas>
            </div>
          }
        </div>
      </section>
    }
  </main>
</div>
